import { FC } from 'react'
import './EnpalEmbeddedVideo.css'

export const EnpalEmbeddedVideo: FC = () => (
  <div className="enpal-embedded-video">
    <iframe
      width="100%"
      height="100%"
      src="https://www.youtube-nocookie.com/embed/A19RPiN45Kk?si=PMsQx4gkLomN5jrb"
      title="Enpal"
      allow="autoplay; clipboard-write; encrypted-media; picture-in-picture"
      referrerPolicy="strict-origin-when-cross-origin"
      allowFullScreen
    />
  </div>
)
